<form clrStepper [formGroup]="requestForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Lieferant wählen</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content>

      <app-request-company-search *ngIf="!isUpdateMode" (submitSupplierNumber)="preFillRow($event)"></app-request-company-search>

      <clr-input-container>
        <label>Betreff</label>
        <input clrInput name="reqsubject" formControlName="reqsubject" />
        <clr-control-error *clrIfError="'required'">Ein Betreff muss angegeben werden</clr-control-error>
        <clr-control-error *clrIfError="'maxLength'; error as err">Betreff zu lang (max. {{ err.name_projectLenght}} Zeichen)</clr-control-error>
      </clr-input-container>

      <clr-input-container>
        <label>Zulieferer</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="reqstreet" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="reqcity" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="reqpostcode" />
      </clr-input-container>
      <app-country-select controlName="reqcountry" label="Land" />
      <clr-select-container *ngIf="isUpdateMode">
        <label>Status</label>
        <select clrSelect formControlName="reqstatus" required>
          <option value="open" selected>Offen</option>
          <option value="running">Abgeschickt</option>
          <option value="rejected">Abgelehnt</option>
          <option value="too expensive">Zu teuer</option>
          <option value="ignored">Ignoriert</option>
          <option value="answered">Beantwortet</option>
          <option value="favored">Auftrag</option>
        </select>
        <clr-control-error>Statusupdate nicht vergessen!</clr-control-error>
      </clr-select-container>
      <clr-input-container *ngIf="(requestForm.value.stepI?.reqstatus === 'answered') || (requestForm.value.stepI?.reqstatus === 'favored') ">
        <label>Angebotsnummer</label>
        <input clrInput formControlName="purchasing_id" />
      </clr-input-container>
      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ requestsData?.requests_date | date: 'dd.MM.yyyy' }}" formControlName="reqdate" />
      </clr-date-container>
      <clr-date-container>
        <label>Abgabe bis</label>
        <input clrDate type="date" placeholder="{{ requestsData?.requests_submit | date: 'dd.MM.yyyy' }}" formControlName="reqsubmit" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" *ngIf="!isUpdateMode" [disabled]="requestForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn" clrStepButton="next" *ngIf="isUpdateMode" [disabled]="disableStepII()">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/request/details', projectId, requestId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <div *ngIf="devMode">Projektleader {{ projectLeader() }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label *ngIf="employee.staff_id !== projectLeader()">{{ employee.firstname }} {{ employee.lastname }}</label>
          <label *ngIf="employee.staff_id === projectLeader()" class="leader"><b>{{ employee.firstname }} {{ employee.lastname }}</b></label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="requestForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/request/details', projectId, requestId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Kunden - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <select clrSelect formControlName="employee_req">
        <option></option>
        <option *ngFor="let person of persons" value="{{ person.pid }}">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" *ngIf="!isUpdateMode" [disabled]="requestForm.invalid" (click)="createRequest()">speichern</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn" clrStepButton="submit" *ngIf="isUpdateMode" [disabled]="requestForm.invalid" (click)="updateRequest(requestId)">speichern</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/request/details', projectId, requestId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>


<pre *ngIf="devMode" class="datepicker-output">
  RequestForm<br>
  CompanyId: {{ companyId }} ProjectId: {{ projectId }}<br>
  {{ requestForm.value | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
  RequestData<br>
  {{ requestsData | json }}
</pre>
